// Analytics Constants for logging and monitoring
export const ANALYTICS_MESSAGES = {
  // COMMON
  USER_CLICKED_CANCEL: 'user_clicked_cancel',

  //REGISTRATION
  // Get Started - Plan Selection (Registration step)
  REG_PLAN_CANCEL: 'reg_plan_cancel',
  REG_PLAN_EXCEPTION: 'reg_plan_step_exception',

  // Personal Information (Registration step)
  REG_PERSONALINFO_CANCEL: 'reg_personalinfo_cancel',
  REG_PERSONALINFO_SUCCESS: 'reg_personalinfo_step_success',
  REG_PERSONALINFO_EXCEPTION: 'reg_personalinfo_step_exception',

  // Account Setup (Registration step)
  REG_ACCOUNTSETUP_CANCEL: 'reg_account_setup_cancel',
  REG_ACCOUNTSETUP_SUCCESS: 'registration_completed_successfully',
  REG_ACCOUNTSETUP_EXCEPTION: 'registration_failed_activation_status_false',

  // Communication Preferences (Registration step)
  REG_COMMUNICATIONPREF_CANCEL: 'reg_communication_preference_skip',
  REG_COMMUNICATIONPREF_SUCCESS: 'reg_communication_preference_success',
  REG_COMMUNICATIONPREF_EXCEPTION:
    'reg_communication_preference_step_exception',

  //FORGOT USERNAME
  FORGOT_USERNAME_LINK_CLICK: 'Forgot_username_edit_click',
  FORGOT_PASSWORD_LINK_CLICK: 'Forgot_password_edit_click',
  FORGOT_USERNAME_CANCEL: 'forgot_username_cancel',
  FORGOT_USERNAME_SUCCESS: 'Forgot_username_save_click',
  FORGOT_USERNAME_EXCEPTION: 'forgot_username_exception',
  FORGOT_USERNAME_SAVE_CLICK: 'Forgot_username_save_click',
  FORGOT_USERNAME_SAVE_FAILURE: 'Forgot_username_save_failure',
  FORGOT_USERNAME_MEMBER_ID_SAVE: 'Forgot_username_member_ID_save_click',

  //FORGOT PASSWORD
  FORGOT_PASSWORD_CANCEL: 'forgot_password_cancel',
  FORGOT_PASSWORD_SUCCESS: 'Forgot_password_save_success',
  FORGOT_PASSWORD_EXCEPTION: 'forgot_password_exception',
  FORGOT_PASSWORD_SAVE_CLICK: 'Forgot_password_save_click',
  FORGOT_PASSWORD_SAVE_FAILURE: 'Forgot_password_save_failure',

  // PROFILE
  PROFILE_PAGE_LOADED: 'profile_page_loaded',
  PROFILE_EDIT_PERSONAL_INFO: 'profile_edit_personal_info',
  PROFILE_EDIT_ADDRESS: 'profile_edit_address',
  PROFILE_EDIT_EMAIL: 'profile_edit_email',
  PROFILE_SAVE_TEXT_COMM_PREFS: 'profile_save_text_communication_preferences',
  PROFILE_SAVE_COMM_CHANNELS: 'profile_save_preferred_communication_channels',
  PROFILE_SAVE_PAPERLESS: 'profile_save_paperless_communication_preference',
  PROFILE_SAVE_LANGUAGE_PREF: 'profile_save_language_preference',
  PROFILE_SAVE_PASSWORD: 'profile_save_password_change',
  PROFILE_CANCEL_PASSWORD: 'profile_cancel_password_change',
  PROFILE_INVALID_EMAIL_ERROR: 'profile_invalid_email_address_error',
  PROFILE_ABANDON: 'profile_page_abandoned',
  PROFILE_CONFIRM_DELETE: 'profile_confirm_delete_account',

  // AUTHENTICATION
  AUTH_SIGNIN_SUCCESS: 'Sign_in_success',
  AUTH_SIGNIN_EXCEPTION: 'Sign_in_failure',
  SIGN_IN_SELECT_SUCCESS: 'Sign_in_select_success',
  SIGN_IN_SELECT_FAILURE: 'Sign_in_select_failure',
  LOGGED_OUT_DUE_TO_INACTIVITY_TITLE: 'Logged Out Due to Inactivity',

  // LANGUAGE TOGGLE
  LANGUAGE_DROPDOWN_OPENED: 'language_dropdown_opened',
  LANGUAGE_OPTION_SELECTED: 'language_option_selected',
  USER_CLICKED_LANGUAGE: 'User Clicked Language Dropdown',
  USER_CLICKED_ENGLISH: 'user_clicked_english',
  USER_CLICKED_SPANISH: 'user_clicked_spanish',

  //SIGN OUT
  POP_USER_SIGN_OUT: 'pop_user_sign_out',
  POP_USER_SIGN_OUT_CANCEL: 'pop_user_sign_out_cancel',
  POP_USER_CONTINUE_SESSION: 'pop_user_continue_session',
  POP_USER_END_SESSION: 'pop_user_end_session',

  //AUTHORIZATION - DEPENDENT CONSENT
  POP_AUTHORIZATION_CONSENT: 'pop_authorization_consent',
  POP_AUTHORIZATION_CONSENT_CANCEL: 'pop_authorization_consent_cancel',
  POP_AUTHORIZATION_REMOVE_ACCESS: 'pop_authorization_remove_access',
  POP_AUTHORIZATION_KEEP_ACCESS: 'pop_authorization_keep_access',

  //PAPERLESS COMMUNICATION
  POP_PAPERLESS_COMMUNICATION_OPT_IN: 'pop_paperless_communication_opt_in',
  POP_PAPERLESS_COMMUNICATION_OPT_OUT: 'pop_paperless_communication_opt_out',

  // LOCKOUT
  POP_ACCOUNT_LOCKOUT: 'pop_account_lockout',

  //Logged out due to inactivity
  POP_LOGGED_OUT_DUE_TO_INACTIVITY: 'pop_logged_out_due_to_inactivity',

  // Claims Smart Search
  POP_CLAIMS_DENIED: 'pop_claims_denied',
 
 // FORGOT USERNAME
  POP_MEMBER_ID_NOT_RECOGNIZED: 'pop_member_id_not_recognized',

  LOGGED_OUT_DUE_TO_INACTIVITY: 'logged_out_due_to_inactivity',

  // SSO Interstitial
  SSO_INTERSTITIAL_PAGE_LOAD: 'SSO_page_load_view',
  SSO_LAUNCH_SUCCESS: 'SSO_launch_success',
  SSO_ERROR: 'SSO_page_error_view',

  // PROFILE FEATURES
  PROFILE_SELECT: 'Profile_select_click',
  EMAIL_EDIT_CLICK: 'Email_edit_click',
  EMAIL_SAVE_SUCCESS: 'Email_save_success',
  EMAIL_SAVE_FAILURE: 'Email_save_failure',
  TEXT_COMM_PREF_EDIT: 'Communication_preference_edit_click',
  TEXT_COMM_PREF_OPTIN: 'Communication_preference_save_optin_click',
  TEXT_COMM_PREF_OPTOUT: 'Communication_preference_save_optout_click',
  TEXT_COMM_PREF_CANCEL: 'Communication_preference_cancel_click',
  TEXT_COMM_PREF_FAILURE: 'Communication_preference_save_failure',
  PREF_CHANNEL_EDIT: 'Preferred_channel_edit_click',
  PREF_CHANNEL_SELECT_EMAIL: 'Preferred_channel_email_select_click',
  PREF_CHANNEL_SELECT_TEXT: 'Preferred_channel_text_select_click',
  PREF_CHANNEL_SAVE_FAILURE: 'Preferred_channel_save_failure',
  PREF_CHANNEL_CANCEL: 'Preferred_channel_cancel_click',
  PAPERLESS_EDIT_CLICK: 'Paperless_communication_edit_click',
  PAPERLESS_CLICK_OPTIN: 'Paperless_communication_optin_click',
  PAPERLESS_CLICK_OPTOUT: 'Paperless_communication_optout_click',
  PAPERLESS_SAVE_FAILURE: 'Paperless_communication_save_failure',
  PAPERLESS_CANCEL: 'Paperless_communication_cancel_click',
  LANGUAGE_PREF_EDIT: 'Language_preferences_select_click',
  LANGUAGE_PREF_SAVE: 'Language_preferences_save_click',
  LANGUAGE_PREF_CANCEL: 'Language_preferences_cancel_click',
  PASSWORD_EDIT_SELECTED: 'Password_edit_click',
  PASSWORD_SAVE: 'Password_save_click',
  PASSWORD_EDIT_FAILURE: 'Password_edit_failure',
  PASSWORD_EDIT_CANCEL: 'Password_cancel_click',
  DELETE_USER: 'Delete_user_click',
  SIGN_OUT_SUCCESS: 'Sign_out_success',
  SIGN_OUT_CANCEL: 'Sign_out_cancel_success',

  // Dashboard Banner
  FIND_DOCTOR_BANNER_CLICK: 'Find_doctor_button_click',
  DASHBOARD_BANNER_LOAD_ERROR: 'Dashboard_banner_load_error_view',

  //Side Navigation Link Click Suffix
  SIDE_NAV_LINK_CLICK_SUFFIX: '_side_navigation_link_click',

  //Dashboard Tile Click Suffix
  DASHBOARD_TILE_CLICK_SUFFIX: '_dashboard_tile_click',

  
} as const;

// Screen names for analytics tracking
export const SCREEN_NAMES = {
  SIGN_IN: 'SignIn',
  DASHBOARD: 'Dashboard',
  PROFILE: 'Profile',
  MEDICAL_CLAIMS: 'MedicalClaims',
  FORGOT_PASSWORD: 'ForgotPassword',
  FORGOT_USERNAME: 'ForgotUsername',
  REGISTRATION: 'Registration',
  HEADER: 'Header',
} as const;

// Types for better type safety
export type AnalyticsMessage =
  (typeof ANALYTICS_MESSAGES)[keyof typeof ANALYTICS_MESSAGES];
export type ScreenName = (typeof SCREEN_NAMES)[keyof typeof SCREEN_NAMES];
